import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

const ComingSoon = ({ title, blurb }) => {
  const is404 = title === "Page Not Found";
  return (
    <section className="bg-white text-[#121212] py-24 md:py-32" data-testid="coming-soon-page">
      {is404 && (
        <Seo
          title="404 — Page Not Found — #whatshesaidproject"
          description="The page you are looking for does not exist."
          path="/404"
        />
      )}
      <div className="max-w-6xl mx-auto px-6">
        <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-3">
          Under Construction — Phase 2
        </span>
        <h1 className="font-disp text-[clamp(36px,5vw,64px)] leading-[1.05] tracking-tight font-normal text-[#121212] mb-6">
          {title}
        </h1>
        <p className="text-[17px] text-[#555555] leading-relaxed max-w-2xl mb-10">{blurb}</p>
        <div className="flex flex-wrap items-center gap-6">
          <Link
            to="/"
            data-testid="coming-soon-home-link"
            className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors"
          >
            Return to Homepage →
          </Link>
          <Link
            to="/connect"
            data-testid="coming-soon-connect-link"
            className="inline-flex items-center justify-center px-6 py-3.5 bg-[#121212] text-white text-xs font-mono uppercase tracking-[.14em] hover:bg-[#e02020] transition-colors rounded-none"
          >
            Collaborate
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
